import { alert } from "./alert";
export const PLUGIN_NAME = "alert";
export const PLUGIN_FACTORY = alert;
/**
 * Helper method to register the alert Plugin with a Jet.js instance
 */
export const register = (jetjs, opts) => {
    // register plugin
    jetjs.registerPlugin(PLUGIN_NAME, PLUGIN_FACTORY);
};
//# sourceMappingURL=index.js.map